import { useSearchParams } from "react-router-dom";

import { FT_ASSET_REQUEST_PATH } from "constants/request";
import { persistor } from "store";

import classes from "./AppError.module.scss";
import { ERROR_TYPES } from "constants/common";

export const AppError = () => {
  const [searchParams] = useSearchParams();

  window.document.title = "Error | FirsTech Inc.";

  const robotImgUri = `${FT_ASSET_REQUEST_PATH}default/robot-error.svg`;
  const logoImgUri = `${FT_ASSET_REQUEST_PATH}default/firstech-logo-white.svg`;

  const error = searchParams.get("error");
  const errorDescription = searchParams.get("error_description");

  if (
    !!error &&
    (error === ERROR_TYPES.CONFIGURATION_ERROR ||
      error === ERROR_TYPES.CLIENT_NOT_FOUND)
  ) {
    console.error(
      "The client wasn't found. Clearing local and session storages!"
    );

    localStorage.clear();
    sessionStorage.clear();
  }

  persistor.purge();

  const genericError = () => {
    return (
      <>
        <p>
          The site you are trying to access, which is managed by FirsTech Inc.,
          could be experiencing a service outage or planned downtime to update
          system configurations.
        </p>
        <p>
          We track these errors automatically, but if the problem persists
          please contact your support team.
        </p>
      </>
    );
  };

  const handleErrorOutput = () => {
    if (!error) {
      return genericError();
    }

    if (
      error === ERROR_TYPES.CONFIGURATION_ERROR ||
      error === ERROR_TYPES.CLIENT_NOT_FOUND
    ) {
      return (
        <div>
          <p>{errorDescription}</p>
          {genericError()}
        </div>
      );
    } else {
      return genericError();
    }
  };

  return (
    <>
      <div className={classes.ErrorPage}>
        <div className={classes.Content}>
          <div className={classes.ErrorMessageContainer}>
            <div>
              <h1>Oops...</h1>
              <h2>Sorry, something went wrong.</h2>
              <div className={classes.Messages}>
                {handleErrorOutput()}
                <p>
                  <strong>Apologies and please try again.</strong>
                </p>
              </div>
            </div>
          </div>
          <div className={classes.ImageContainer}>
            <img src={robotImgUri} alt="Tobi, the FirsTech, robot is sad." />
          </div>
        </div>
        <div className={classes.FooterContainer}>
          <div className={classes.FooterBar}></div>
          <div className={classes.LogoContainer}>
            <div>
              <img src={logoImgUri} alt="FirsTech Inc." />
            </div>
            <p>a Payment Processing Company</p>
          </div>
        </div>
      </div>
    </>
  );
};
